<template>
  <div>
    <div>
      销售记录共
      <span class="num color1">{{ item.totalNum || 0 }}</span>
      条，
      <span class="num color2">{{ item.registeredNum || 0 }}</span>
      条{{ registerMsg }}，
      <template v-if="item.classify == 3">
        <!-- 处方今日增加 未上传状态 -->
        <template>
          <span class="num color3">{{ item.unRegisteredNum || 0 }}</span>
          条{{ unRegisterMsg }}；
        </template>
        <template v-if="isToday">
          <span class="num color4">{{ item.toRegisteredNum || 0 }}</span>
          条{{ toRegisterMsg }}；
        </template>
      </template>
      <template v-else>
        <!-- 四类&&特殊 今日显示待登记 昨日之前为 未登记 -->
        <template v-if="isToday">
          <span class="num color3">{{ item.toRegisteredNum || 0 }}</span>
          条{{ toRegisterMsg }}；
        </template>
        <template v-else>
          <span class="num color3">{{ item.unRegisteredNum || 0 }}</span>
          条{{ unRegisterMsg }}；
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item', 'isToday'],
  computed: {
    normalMsg() {
      return this.item.classify == 3 ? '正常' : '完成登记';
    },
    alarmMsg() {
      return this.item.classify == 3 ? '存在异常' : '未完成登记';
    },
    registerMsg() {
      return this.item.classify == 3 ? '凭处方销售' : '已登记';
    },
    unRegisterMsg() {
      return this.item.classify == 3 ? '未凭处方销售' : '未登记';
    },
    toRegisterMsg() {
      return this.item.classify == 3 ? '待上传' : '待登记';
    }
  }
};
</script>
<style scoped>
.num {
  font-weight: 600;
}
.color1 {
  color: #262626;
}
.color2 {
  color: #1e8dff;
}
.color3 {
  color: #ff4e47;
}
.left {
  text-align: left;
}
.color4 {
  color: #ff8200;
}
</style>
